import React from 'react';
import styles from './Clients.module.scss';
import { useRef, useState, useEffect, useContext } from 'react';
import { axiosBackend } from '../../axios/Axios.js';
import Pagination from '@mui/material/Pagination';
import "./Pagination.css";
import { getToken } from "../../services/auth";
import Modal from "./components/Modal"
import dayjs, { Dayjs } from 'dayjs';
import { useSnackbar } from 'notistack';

const IconEye  = () => {
  return (
  <svg className={styles.eye_icon} width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.5 5.3159C0.776094 4.67954 1.27053 4.20765 1.73503 3.7192C2.68481 2.72012 3.76805 1.88832 4.99252 1.24774C6.78361 0.311693 8.67788 -0.0770925 10.6951 0.182098C12.4062 0.402198 13.9311 1.08081 15.3306 2.05982C16.4557 2.8469 17.4361 3.78963 18.2644 4.88626C18.5754 5.29794 18.581 5.68602 18.2683 6.09065C16.8156 7.97225 15.0242 9.41646 12.7897 10.2768C11.8438 10.6413 10.8606 10.8399 9.84529 10.8716C9.77592 10.8737 9.70725 10.8885 9.63822 10.8973H9.3572C9.28219 10.8885 9.20788 10.8737 9.13252 10.8712C7.67352 10.8223 6.3103 10.4194 5.0221 9.75031C3.78003 9.1055 2.68305 8.26349 1.72235 7.25067C1.26278 6.76645 0.772573 6.29843 0.5 5.667L0.5 5.3159ZM9.5037 9.98379C10.975 9.98027 12.3485 9.59747 13.6381 8.90583C15.1186 8.1117 16.3663 7.03726 17.4129 5.72863C17.6407 5.44373 17.6383 5.53706 17.4164 5.2592C16.3705 3.94987 15.1224 2.87578 13.6433 2.07989C12.4735 1.45058 11.2275 1.07271 9.896 1.00862C8.28839 0.931496 6.78396 1.315 5.37285 2.06862C3.88074 2.86556 2.62423 3.94846 1.57198 5.26836C1.36033 5.53354 1.35505 5.44373 1.57937 5.72441C2.6112 7.01402 3.83743 8.07649 5.2915 8.8692C6.604 9.58479 8.00208 9.98062 9.50405 9.98379H9.5037Z" fill="white"/>
  <path d="M9.4958 1.90039C11.4813 1.89828 13.0907 3.50413 13.0924 5.48926C13.0945 7.47263 11.4873 9.07919 9.49897 9.08131C7.51313 9.08342 5.90446 7.47827 5.90235 5.49243C5.90023 3.50942 7.50785 1.90215 9.4958 1.90039ZM9.47255 8.18858C10.9382 8.21429 12.1631 7.01694 12.1983 5.52483C12.2324 4.05843 11.0192 2.81988 9.52256 2.79382C8.05687 2.76812 6.83205 3.96546 6.79683 5.45757C6.76268 6.92397 7.97587 8.16252 9.47255 8.18858Z" fill="white"/>
  </svg>
  );
};

const Clients_obj = ({clients}) => (
  <>
    {clients.map(client => (
      <ClientItem key={client.uuid} name={client.name} logo_url={client.logo_url} c_key={client.key} id={client.uuid} type={"Projeto e sustentação"} />
    ))}
  </>
); 




function ClientItem(props) {
  return (
    <div className={styles.flex_col3}>
              <div className={styles.flex_row2}>
                <div className={styles.content_box2}>
                  <div className={styles.content_box2_draw}>
                  <img
                    className={styles.image1}
                    src={props.logo_url}
                    alt="alt text"
                  />
                  </div>
                  <div className={styles.client_name}>{props.name}</div>
                </div>
                <div className={styles.flex_row4}>
                  <div className={styles.info21}>{props.c_key}</div>
                  <div className={styles.info3}>{props.type}</div>
                  <div className={styles.content_box_relat}>
                  <a href={"/clients/" + props.id} className={styles.box1}>
                    <IconEye />
                  </a>
                  </div>
                </div>
              </div>
              <hr className={styles.line} size={1} />
            </div>
  )
}

const CLIENTS_URL = "/clients"

function ClientsContent(props) {
  const [clients, setClients] = useState([]);
  
  const [clientsShow, setClientsShow] = useState([]);

  const [page, setPage] = useState(1);

  const [pageTotal, setPageTotal] = useState(1);
  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [logoUpload, setLogoUpload] = useState(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const [formData, setFormData] = useState({
    name: '',
    keyword: '',
    escope: '',
    start: dayjs()
  });

  const handleChangePage = async (e) => {
    setPage(e)
    setClientsShow(clients.slice( ((e-1)*8), (e*8) ))
  };

  const handleReload = async (inserted) => {
    axiosBackend.get(
      CLIENTS_URL, {params: {
        "maxResult": 8,
        "startAt": 0
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getToken()}`
      }
    }
    ).then( (res) => {
        setClients(res.data.result);
        setPageTotal(res.data.config.pages);
        setClientsShow(res.data.result.slice(0, 8));
        setPage(1);
    }).catch(err => {
        enqueueSnackbar('Falha ao carregar clientes.', { 
          variant: 'error'
        })
    });
  };

  useEffect(() => {
    const response = axiosBackend.get(
      CLIENTS_URL, {params: {
        "maxResult": 8,
        "startAt": 0
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getToken()}`
      }
    }
    ).then( (res) => {
        setClients(res.data.result)
        setPageTotal(res.data.config.pages)
        setLoading(false)
        setClientsShow(res.data.result.slice(0, 8))

    }).catch(err => {
          enqueueSnackbar('Falha ao carregar clientes.', { 
            variant: 'error'
          })
    });
    setLoading(false)
  }, []);


  return (
    <div className={styles.group}>
      <Modal handleReload={handleReload} logoUpload={logoUpload} setLogoUpload={setLogoUpload} formData={formData} setFormData={setFormData} isOpen={isModalOpen} onClose={() => setModalOpen(false)} uuid={props.uuid}/>
      <div className={styles.flex_col}>
        <div className={styles.flex_row}>
          <h1 className={styles.title}>Clientes</h1>
          <button onClick={() => setModalOpen(true)} className={styles.button_add}>+ Adicionar cliente</button>
          {/* <div className={styles.content_box}>
            <div className={styles.flex_row1}>
              <img
                className={styles.icon1}
                src={require('./assets/66110f65be44cedb9d2b365cf450d7db.png')}
                alt="alt text"
              />
              <div className={styles.info5}>Buscar...</div>
            </div>
          </div> */}
        </div>

        <div className={styles.box}>
          <div className={styles.flex_col1}>
            <div className={styles.flex_col2}>
              <div className={styles.flex_row2}>
                <div className={styles.content_box2}>
                  <div className={styles.info}>Nome do cliente </div>
                </div>
                <div className={styles.flex_row4}>
                  <p className={styles.info1}>Keyword</p>
                  <p className={styles.info2}>Tipo de contrato </p>
                  <p className={styles.info1}>Relatórios</p>
                </div>
              </div>
              <hr className={styles.line} size={1} />
            </div>
            <Clients_obj clients={clientsShow}/>
          </div>
          <Pagination
            count={pageTotal}
            shape="rounded"
            page={page}
            onChange={(e, value) => handleChangePage(value)}
          />
          
        </div>
      </div>
    </div>
);
}

export default ClientsContent;
